import * as React from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';


const InputDialog = ({keyText, valueText, handleChange}) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
      <React.Fragment>
        <div onClick={handleClickOpen}>{keyText}: {valueText}</div>
        <Dialog
          open={open}
          onClose={handleClose}
        >
          <form onSubmit={(event => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            console.log(formJson);
            const context = formJson.context;
            handleChange(context);
            handleClose();
          }
          )}>
            <DialogTitle>{keyText}</DialogTitle>
            <DialogContent>
            <TextField
                autoFocus
                required
                margin="dense"
                id="name"
                name="context"
                type="text"
                fullWidth
            />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose}>Cancel</Button>
              <Button type="submit">OK</Button>
            </DialogActions>
          </form>
        </Dialog>
      </React.Fragment>
  );
}

export default InputDialog;